import React from 'react';

import { InfoCircleTwoTone } from '@ant-design/icons';
// Local Deps

import './IHelpButton.scss';

class IHelpButton extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <div className="nf-iHelp-button">
        <a href="/help" target="_new">
          <button className=" md-btn md-btn-raised" data-tut="reactour__help">
            {' '}
            <InfoCircleTwoTone style={{ fontSize: '20px' }} twoToneColor="#ff7c52" />
          </button>
        </a>
      </div>
    );
  }
}


export default IHelpButton;



// WEBPACK FOOTER //
// ./src/components/primitives/IHelpButton/IHelpButton.jsx